interface ITransformation {
  position: any;
  scale: any;
}

interface ILastPointInfo {
  width: number;
  distance: number;
}

export class TierStepSizeChangeAction {

  constructor(
    public readonly transformations: Array<ITransformation>,
    public readonly pointInfo: ILastPointInfo,
    public readonly tierCustomId: number
  ) {

  }

}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/actions/TierStepSizeChangeAction.ts